__turbopack_context__.v({
  "info": "tweet-info-module__7VNbKG__info",
  "infoIcon": "tweet-info-module__7VNbKG__infoIcon",
  "infoLink": "tweet-info-module__7VNbKG__infoLink",
});
